import jwtDecode, { JwtPayload } from 'jwt-decode';

/**
 * Check if JWT token is valid and not expired
 */
export const isTokenValid = (accessToken: string) => {
	if (accessToken) {
		try {
			const decoded = jwtDecode<JwtPayload>(accessToken);
			const currentTime = Date.now() / 1000;

			if (!decoded.exp) {
				console.error('[JWT] Token missing expiration claim');
				return false;
			}

			const isValid = decoded.exp > currentTime;

			if (!isValid) {
				console.error('[JWT] Token has expired');
			}

			return isValid;
		} catch (error) {
			console.error('[JWT] Failed to parse token:', error);
			return false;
		}
	}

	return false;
};

/**
 * Get time until token expires (in milliseconds)
 * Returns null if token is invalid or missing expiration
 */
export const getTimeUntilExpiry = (token: string): number | null => {
	if (!token) return null;

	try {
		const decoded = jwtDecode<JwtPayload>(token);

		if (!decoded.exp) {
			console.error('[JWT] Token missing expiration claim');
			return null;
		}

		const expiresAt = decoded.exp * 1000; // Convert to milliseconds
		const now = Date.now();
		const timeRemaining = expiresAt - now;

		return timeRemaining > 0 ? timeRemaining : 0;
	} catch (error) {
		console.error('[JWT] Failed to get token expiry:', error);
		return null;
	}
};

export type DoratJwtPayload = JwtPayload & {
	MustChangePassword?: string | boolean;
};

export const mustChangePasswordFromToken = (accessToken: string): boolean => {
	if (!accessToken) return false;

	try {
		const decoded = jwtDecode<DoratJwtPayload>(accessToken);
		const claim = decoded?.MustChangePassword;

		if (typeof claim === 'boolean') return claim;

		if (typeof claim === 'string') return claim.toLowerCase() === 'true';
	} catch (error) {
		console.error('Cannot decode JWT MustChangePassword claim', error);
	}
	return false;
};
